<script lang="ts" setup>
import type { NeonMode } from '@arcual/lib-app-neon';
import { NeonModeUtils } from '@arcual/lib-app-neon';
import { onMounted } from 'vue';

onMounted(() => {
  const mode = localStorage.getItem('mode') as NeonMode;
  NeonModeUtils.init(mode);
});
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition mode="out-in" name="neon-fade-transition">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<style lang="scss">
@use './global';
</style>
